import * as React from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';

import { DataTableView } from 'src/core/ui/data-table.view';

interface Props extends ComponentViewProps<DataSet<TaxonomySummary>> {
	onItemDoubleClick: (item: TaxonomySummary) => void;
}

@observer
export class TaxonomyListView extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	render() {
		const { model, setBusy } = this.props;
		const columns = [
			{
				key: 'displayName',
				title: 'Name',
				dataIndex: 'displayName',
				render: (text, record: TaxonomySummary) => <Link to={`/general/taxonomies/${record.id}`}>{text}</Link>,
			}
		];

		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						columns={columns}
						model={model}
						itemDoubleClick={(item) => {
							if (this.props.onItemDoubleClick) {
								this.props.onItemDoubleClick(item);
							}
						}}
						setBusy={this.props.setBusy}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/taxonomies/list/taxonomy-list.view.tsx